import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {closeSuccess} from "../redux/actions";

export const SuccessRequest = () => {
    const dispatch = useDispatch()
    const requestSuccess = useSelector(state => state.app.requestSuccess)
    const requestSuccessMessage = useSelector(state => state.app.requestSuccessMessage)

    if (!requestSuccess) {
        return null;
    }
    return (
        <div className="request-popup">
            <div className="request-popup__form">
                <div className="request-popup__close" onClick={() => dispatch(closeSuccess())}>X</div>
                <div className="request-popup__succcess" dangerouslySetInnerHTML={{ __html: requestSuccessMessage }}/>
            </div>
        </div>
    )
}